// Map a 0-100 numeric score onto an iFocus-style letter grade. A+ = elite,
// F = critical. Lets users grok the result in 0.5s without doing math.
export const scoreToGrade = (score) => {
  if (score >= 95) return "A+";
  if (score >= 85) return "A";
  if (score >= 75) return "A-";
  if (score >= 65) return "B";
  if (score >= 55) return "C";
  if (score >= 40) return "D";
  return "F";
};

export const ScoreCircle = ({ score, size = 120, strokeWidth = 8, color = "#2563EB", label, showGrade = false }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - (score / 100) * circumference;

  const getColor = (score) => {
    if (score >= 80) return "#10B981";
    if (score >= 60) return "#F59E0B";
    if (score >= 40) return "#F97316";
    return "#EF4444";
  };
  const grade = scoreToGrade(score);

  return (
    <div className="score-circle relative" style={{ width: size, height: size }} data-testid="score-circle">
      <svg width={size} height={size}>
        <circle
          className="score-circle-bg"
          cx={size / 2}
          cy={size / 2}
          r={radius}
        />
        <circle
          className="score-circle-progress score-ring"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={color || getColor(score)}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{ '--score-offset': offset }}
        />
      </svg>
      <div className="score-circle-text">
        <span className="font-mono text-3xl font-bold">{score}</span>
        {label && <span className="text-xs text-gray-500">{label}</span>}
      </div>
      {showGrade && (
        <span
          className="absolute -top-1 -right-1 px-2 py-0.5 text-xs font-black bg-[var(--color-bg)] border-2 rounded font-['JetBrains_Mono']"
          style={{ borderColor: getColor(score), color: getColor(score) }}
          data-testid="score-grade-badge"
        >
          {grade}
        </span>
      )}
    </div>
  );
};
